<template>
  <BaseDialog fullscreen hideConfirm hideCancel @close="$emit('close')">
    <div class="flex flex-col items-center justify-center h-full">
      <div class="scanner-container">
        <QrcodeStream
          class="qrcode-reader"
          camera="auto"
          :formats="['qr_code', 'code_39']"
          @init="onInit"
          @decode="onDecode"
        >
          <div v-if="init" class="qrcode-reader__prompt">等待開啟相機...</div>
        </QrcodeStream>
      </div>
      <p class="text-white mt-6 text-sm opacity-80">將條碼對準相機畫面即可自動掃描</p>
    </div>
  </BaseDialog>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { QrcodeStream } from 'vue-qrcode-reader'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'

export default defineComponent({
  name: 'CarrierNumCameraScanDialog',
  components: {
    QrcodeStream,
    BaseDialog,
  },
  emits: ['scan', 'close'],
  setup (props, { emit }) {
    const init = ref(true)

    const onInit = async (promise) => {
      init.value = true
      try {
        await promise
      } catch (error) {
        console.log('camera init error', error)
        window.$message.error('無法開啟相機')
      } finally {
        init.value = false
      }
    }

    const onDecode = (decodedString) => {
      emit('scan', decodedString)
      emit('close')
    }

    return {
      init,
      onInit,
      onDecode,
    }
  },
})
</script>

<style lang="postcss" scoped>
.scanner-container {
  @apply w-[429px] h-[429px] rounded-[30px] overflow-hidden;
  @apply bg-white bg-opacity-50;
}
.qrcode-reader {
  @apply flex items-center justify-center;
}

:deep(.el-dialog) {
  @apply flex items-center justify-center bg-transparent;
}

:deep(.qrcode-stream-overlay) {
  @apply flex items-center justify-center;
}
</style>
